// src/data/TaxonomyData.js - Complete IAB Taxonomy Data from TSV file
// Complete IAB Taxonomy Data - Based on Content 1.0 to Ad Product 2.0.tsv

export const COMPLETE_TAXONOMY_DATA = {
  // Main content categories
  contentCategories: [
    { value: 'IAB1', label: 'Arts & Entertainment' },
    { value: 'IAB2', label: 'Automotive' },
    { value: 'IAB3', label: 'Business' },
    { value: 'IAB4', label: 'Careers' },
    { value: 'IAB5', label: 'Education' },
    { value: 'IAB6', label: 'Family & Parenting' },
    { value: 'IAB7', label: 'Health & Fitness' },
    { value: 'IAB8', label: 'Food & Drink' },
    { value: 'IAB9', label: 'Hobbies & Interests' },
    { value: 'IAB10', label: 'Home & Garden' },
    { value: 'IAB11', label: 'Law, Gov\'t & Politics' },
    { value: 'IAB12', label: 'News' },
    { value: 'IAB13', label: 'Personal Finance' },
    { value: 'IAB14', label: 'Society' },
    { value: 'IAB15', label: 'Science' },
    { value: 'IAB16', label: 'Pets' },
    { value: 'IAB17', label: 'Sports' },
    { value: 'IAB18', label: 'Style & Fashion' },
    { value: 'IAB19', label: 'Technology & Computing' },
    { value: 'IAB20', label: 'Travel' },
    { value: 'IAB21', label: 'Real Estate' },
    { value: 'IAB22', label: 'Shopping' },
    { value: 'IAB23', label: 'Religion & Spirituality' },
    { value: 'IAB24', label: 'Uncategorized' },
    { value: 'IAB25', label: 'Non-Standard Content' },
    { value: 'IAB26', label: 'Illegal Content' }
  ],

  // Complete detailed mapping with all subcategories and ad products from TSV
  detailedMapping: {
    'IAB1': {
      label: 'Arts & Entertainment',
      baseAdProduct: { id: 1008, name: 'Culture and Fine Arts' },
      subcategories: [
        { value: 'IAB1-1', label: 'Books & Literature', adProduct: { id: 1422, name: 'Media > Books and Audio Books' } },
        { value: 'IAB1-2', label: 'Celebrity Fan/Gossip', adProduct: { id: 1419, name: 'Media' } },
        { value: 'IAB1-3', label: 'Fine Art', adProduct: { id: 1008, name: 'Culture and Fine Arts' } },
        { value: 'IAB1-4', label: 'Humor', adProduct: { id: 1315, name: 'Events and Performances' } },
        { value: 'IAB1-5', label: 'Movies', adProduct: { id: 1317, name: 'Events and Performances > Cinemas and Movie Events' } },
        { value: 'IAB1-6', label: 'Music', adProduct: { id: 1419, name: 'Media' } },
        { value: 'IAB1-7', label: 'Television', adProduct: { id: 1429, name: 'Media > Live Television' } }
      ]
    },

    'IAB2': {
      label: 'Automotive',
      baseAdProduct: { id: 1551, name: 'Vehicles' },
      subcategories: [
        { value: 'IAB2-1', label: 'Auto Parts', adProduct: { id: 1558, name: 'Vehicles > Automotive Products > Automotive Parts and Accessories' } },
        { value: 'IAB2-2', label: 'Auto Repair', adProduct: { id: 1562, name: 'Vehicles > Automotive Services > Auto Repair' } },
        { value: 'IAB2-3', label: 'Buying/Selling Cars', adProduct: { id: 1553, name: 'Vehicles > Automotive Ownership' } },
        { value: 'IAB2-4', label: 'Car Culture', adProduct: { id: 1551, name: 'Vehicles' } },
        { value: 'IAB2-5', label: 'Certified Pre-Owned', adProduct: { id: 1551, name: 'Vehicles' } },
        { value: 'IAB2-6', label: 'Convertible', adProduct: { id: 1551, name: 'Vehicles' } },
        { value: 'IAB2-7', label: 'Coupe', adProduct: { id: 1551, name: 'Vehicles' } },
        { value: 'IAB2-8', label: 'Crossover', adProduct: { id: 1551, name: 'Vehicles' } },
        { value: 'IAB2-9', label: 'Diesel', adProduct: { id: 1551, name: 'Vehicles' } },
        { value: 'IAB2-10', label: 'Electric Vehicle', adProduct: { id: 1551, name: 'Vehicles' } },
        { value: 'IAB2-11', label: 'Hatchback', adProduct: { id: 1551, name: 'Vehicles' } },
        { value: 'IAB2-12', label: 'Hybrid', adProduct: { id: 1551, name: 'Vehicles' } },
        { value: 'IAB2-13', label: 'Luxury', adProduct: { id: 1551, name: 'Vehicles' } },
        { value: 'IAB2-14', label: 'MiniVan', adProduct: { id: 1551, name: 'Vehicles' } },
        { value: 'IAB2-15', label: 'Motorcycles', adProduct: { id: 1551, name: 'Vehicles' } },
        { value: 'IAB2-16', label: 'Off-Road Vehicles', adProduct: { id: 1551, name: 'Vehicles' } },
        { value: 'IAB2-17', label: 'Performance Vehicles', adProduct: { id: 1551, name: 'Vehicles' } },
        { value: 'IAB2-18', label: 'Pickup', adProduct: { id: 1551, name: 'Vehicles' } },
        { value: 'IAB2-19', label: 'Road-Side Assistance', adProduct: { id: 1551, name: 'Vehicles' } },
        { value: 'IAB2-20', label: 'Sedan', adProduct: { id: 1551, name: 'Vehicles' } },
        { value: 'IAB2-21', label: 'Trucks & Accessories', adProduct: { id: 1551, name: 'Vehicles' } },
        { value: 'IAB2-22', label: 'Vintage Cars', adProduct: { id: 1551, name: 'Vehicles' } },
        { value: 'IAB2-23', label: 'Wagon', adProduct: { id: 1551, name: 'Vehicles' } }
      ]
    },

    'IAB3': {
      label: 'Business',
      baseAdProduct: { id: 1010, name: 'Business and Industrial' },
      subcategories: [
        { value: 'IAB3-1', label: 'Advertising', adProduct: { id: 1011, name: 'Business and Industrial > Advertising and Marketing' } },
        { value: 'IAB3-2', label: 'Agriculture', adProduct: { id: 1010, name: 'Business and Industrial' } },
        { value: 'IAB3-3', label: 'Biotech/Biomedical', adProduct: { id: 1043, name: 'Business and Industrial > Medical and Biotechnology' } },
        { value: 'IAB3-4', label: 'Business Software', adProduct: { id: 1085, name: 'Computer Software > Enterprise Computer Software' } },
        { value: 'IAB3-5', label: 'Construction', adProduct: { id: 1038, name: 'Business and Industrial > Industrials > Construction and Engineering' } },
        { value: 'IAB3-6', label: 'Forestry', adProduct: { id: 1034, name: 'Business and Industrial > Forestry and Logging' } },
        { value: 'IAB3-7', label: 'Government', adProduct: { id: 1010, name: 'Business and Industrial' } },
        { value: 'IAB3-8', label: 'Green Solutions', adProduct: { id: 1032, name: 'Business and Industrial > Energy Industry > Green Energy' } },
        { value: 'IAB3-9', label: 'Human Resources', adProduct: { id: 1012, name: 'Business and Industrial > Business Services > Human Resources and Recruiting' } },
        { value: 'IAB3-10', label: 'Logistics', adProduct: { id: 1019, name: 'Business and Industrial > Business Services > Logistics and Delivery' } },
        { value: 'IAB3-11', label: 'Marketing', adProduct: { id: 1011, name: 'Business and Industrial > Advertising and Marketing' } },
        { value: 'IAB3-12', label: 'Metals', adProduct: { id: 1443, name: 'Metals' } }
      ]
    },

    'IAB4': {
      label: 'Careers',
      baseAdProduct: { id: 1271, name: 'Jobs and Career' },
      subcategories: [
        { value: 'IAB4-1', label: 'Career Planning', adProduct: { id: 1271, name: 'Jobs and Career' } },
        { value: 'IAB4-2', label: 'College', adProduct: { id: 1281, name: 'Learning and Knowledge > Education' } },
        { value: 'IAB4-3', label: 'Financial Aid', adProduct: { id: 1360, name: 'Financial Services' } },
        { value: 'IAB4-4', label: 'Job Fairs', adProduct: { id: 1271, name: 'Jobs and Career' } },
        { value: 'IAB4-5', label: 'Job Search', adProduct: { id: 1271, name: 'Jobs and Career' } },
        { value: 'IAB4-6', label: 'Resume Writing', adProduct: { id: 1271, name: 'Jobs and Career' } },
        { value: 'IAB4-7', label: 'Nursing', adProduct: { id: 1271, name: 'Jobs and Career' } },
        { value: 'IAB4-8', label: 'Scholarships', adProduct: { id: 1281, name: 'Learning and Knowledge > Education' } },
        { value: 'IAB4-9', label: 'Telecommuting', adProduct: { id: 1271, name: 'Jobs and Career' } },
        { value: 'IAB4-10', label: 'U.S. Military', adProduct: { id: 1271, name: 'Jobs and Career' } },
        { value: 'IAB4-11', label: 'Career Advice', adProduct: { id: 1271, name: 'Jobs and Career' } }
      ]
    },

    'IAB5': {
      label: 'Education',
      baseAdProduct: { id: 1281, name: 'Learning and Knowledge > Education' },
      subcategories: [
        { value: 'IAB5-1', label: '7-12 Education', adProduct: { id: 1281, name: 'Learning and Knowledge > Education' } },
        { value: 'IAB5-2', label: 'Adult Education', adProduct: { id: 1281, name: 'Learning and Knowledge > Education' } },
        { value: 'IAB5-3', label: 'Art History', adProduct: { id: 1281, name: 'Learning and Knowledge > Education' } },
        { value: 'IAB5-4', label: 'College Administration', adProduct: { id: 1281, name: 'Learning and Knowledge > Education' } },
        { value: 'IAB5-5', label: 'College Life', adProduct: { id: 1281, name: 'Learning and Knowledge > Education' } },
        { value: 'IAB5-6', label: 'Distance Learning', adProduct: { id: 1281, name: 'Learning and Knowledge > Education' } },
        { value: 'IAB5-7', label: 'English as a 2nd Language', adProduct: { id: 1281, name: 'Learning and Knowledge > Education' } },
        { value: 'IAB5-8', label: 'Language Learning', adProduct: { id: 1281, name: 'Learning and Knowledge > Education' } },
        { value: 'IAB5-9', label: 'Graduate School', adProduct: { id: 1281, name: 'Learning and Knowledge > Education' } },
        { value: 'IAB5-10', label: 'Homeschooling', adProduct: { id: 1281, name: 'Learning and Knowledge > Education' } },
        { value: 'IAB5-11', label: 'Homework/Study Tips', adProduct: { id: 1281, name: 'Learning and Knowledge > Education' } },
        { value: 'IAB5-12', label: 'K-6 Educators', adProduct: { id: 1281, name: 'Learning and Knowledge > Education' } },
        { value: 'IAB5-13', label: 'Private School', adProduct: { id: 1281, name: 'Learning and Knowledge > Education' } },
        { value: 'IAB5-14', label: 'Special Education', adProduct: { id: 1281, name: 'Learning and Knowledge > Education' } },
        { value: 'IAB5-15', label: 'Studying Business', adProduct: { id: 1281, name: 'Learning and Knowledge > Education' } }
      ]
    },

    'IAB6': {
      label: 'Family & Parenting',
      baseAdProduct: { id: 1340, name: 'Family and Relationships' },
      subcategories: [
        { value: 'IAB6-1', label: 'Adoption', adProduct: { id: 1340, name: 'Family and Relationships' } },
        { value: 'IAB6-2', label: 'Babies & Toddlers', adProduct: { id: 1340, name: 'Family and Relationships' } },
        { value: 'IAB6-3', label: 'Daycare/Pre School', adProduct: { id: 1340, name: 'Family and Relationships' } },
        { value: 'IAB6-4', label: 'Family Internet', adProduct: { id: 1340, name: 'Family and Relationships' } },
        { value: 'IAB6-5', label: 'Parenting - K-6 Kids', adProduct: { id: 1340, name: 'Family and Relationships' } },
        { value: 'IAB6-6', label: 'Parenting teens', adProduct: { id: 1340, name: 'Family and Relationships' } },
        { value: 'IAB6-7', label: 'Pregnancy', adProduct: { id: 1340, name: 'Family and Relationships' } },
        { value: 'IAB6-8', label: 'Special Needs Kids', adProduct: { id: 1340, name: 'Family and Relationships' } },
        { value: 'IAB6-9', label: 'Eldercare', adProduct: { id: 1340, name: 'Family and Relationships' } }
      ]
    },

    'IAB7': {
      label: 'Health & Fitness',
      baseAdProduct: { id: 1239, name: 'Health and Wellness' },
      subcategories: [
        { value: 'IAB7-1', label: 'Exercise', adProduct: { id: 1244, name: 'Health and Wellness > Fitness and Exercise' } },
        { value: 'IAB7-2', label: 'ADD', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-3', label: 'AIDS/HIV', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-4', label: 'Allergies', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-5', label: 'Alternative Medicine', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-6', label: 'Arthritis', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-7', label: 'Asthma', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-8', label: 'Autism/PDD', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-9', label: 'Bipolar Disorder', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-10', label: 'Brain Tumor', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-11', label: 'Cancer', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-12', label: 'Cholesterol', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-13', label: 'Chronic Fatigue Syndrome', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-14', label: 'Chronic Pain', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-15', label: 'Cold & Flu', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-16', label: 'Deafness', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-17', label: 'Dental Care', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-18', label: 'Depression', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-19', label: 'Dermatology', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-20', label: 'Diabetes', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-21', label: 'Epilepsy', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-22', label: 'GERD/Acid Reflux', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-23', label: 'Headaches/Migraines', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-24', label: 'Heart Disease', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-25', label: 'Herbs for Health', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-26', label: 'Holistic Healing', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-27', label: 'IBS/Crohn\'s Disease', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-28', label: 'Incest/Abuse Support', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-29', label: 'Incontinence', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-30', label: 'Infertility', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-31', label: 'Men\'s Health', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-32', label: 'Nutrition', adProduct: { id: 1255, name: 'Health and Wellness > Nutrition' } },
        { value: 'IAB7-33', label: 'Orthopedics', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-34', label: 'Panic/Anxiety Disorders', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-35', label: 'Pediatrics', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-36', label: 'Physical Therapy', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-37', label: 'Psychology/Psychiatry', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-38', label: 'Senior Health', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-39', label: 'Sexuality', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-40', label: 'Sleep Disorders', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-41', label: 'Smoking Cessation', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-42', label: 'Substance Abuse', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-43', label: 'Thyroid Disease', adProduct: { id: 1239, name: 'Health and Wellness' } },
        { value: 'IAB7-44', label: 'Weight Loss', adProduct: { id: 1244, name: 'Health and Wellness > Fitness and Exercise' } },
        { value: 'IAB7-45', label: 'Women\'s Health', adProduct: { id: 1239, name: 'Health and Wellness' } }
      ]
    },

    'IAB8': {
      label: 'Food & Drink',
      baseAdProduct: { id: 1355, name: 'Food and Beverage Services' },
      subcategories: [
        { value: 'IAB8-1', label: 'American Cuisine', adProduct: { id: 1355, name: 'Food and Beverage Services' } },
        { value: 'IAB8-2', label: 'Barbecues & Grilling', adProduct: { id: 1128, name: 'Consumer Packaged Goods > Barbeque' } },
        { value: 'IAB8-3', label: 'Cajun/Creole', adProduct: { id: 1355, name: 'Food and Beverage Services' } },
        { value: 'IAB8-4', label: 'Chinese Cuisine', adProduct: { id: 1355, name: 'Food and Beverage Services' } },
        { value: 'IAB8-5', label: 'Cocktails/Beer', adProduct: { id: 1006, name: 'Alcohol > Spirits' } },
        { value: 'IAB8-6', label: 'Coffee/Tea', adProduct: { id: 1133, name: 'Consumer Packaged Goods > Beverages > Coffee & Tea' } },
        { value: 'IAB8-7', label: 'Cuisine-Specific', adProduct: { id: 1355, name: 'Food and Beverage Services' } },
        { value: 'IAB8-8', label: 'Desserts & Baking', adProduct: { id: 1355, name: 'Food and Beverage Services' } },
        { value: 'IAB8-9', label: 'Dining Out', adProduct: { id: 1355, name: 'Food and Beverage Services' } },
        { value: 'IAB8-10', label: 'Food Allergies', adProduct: { id: 1473, name: 'Pharmaceuticals' } },
        { value: 'IAB8-11', label: 'French Cuisine', adProduct: { id: 1355, name: 'Food and Beverage Services' } },
        { value: 'IAB8-12', label: 'Health/Lowfat Cooking', adProduct: { id: 1355, name: 'Food and Beverage Services' } },
        { value: 'IAB8-13', label: 'Italian Cuisine', adProduct: { id: 1355, name: 'Food and Beverage Services' } },
        { value: 'IAB8-14', label: 'Japanese Cuisine', adProduct: { id: 1355, name: 'Food and Beverage Services' } },
        { value: 'IAB8-15', label: 'Mexican Cuisine', adProduct: { id: 1355, name: 'Food and Beverage Services' } },
        { value: 'IAB8-16', label: 'Vegan', adProduct: { id: 1355, name: 'Food and Beverage Services' } },
        { value: 'IAB8-17', label: 'Vegetarian', adProduct: { id: 1355, name: 'Food and Beverage Services' } },
        { value: 'IAB8-18', label: 'Wine', adProduct: { id: 1007, name: 'Alcohol > Wine' } }
      ]
    },

    'IAB9': {
      label: 'Hobbies & Interests',
      baseAdProduct: { id: 1257, name: 'Hobbies and Interests' },
      subcategories: [
        { value: 'IAB9-1', label: 'Art/Technology', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-2', label: 'Arts & Crafts', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-3', label: 'Beadwork', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-4', label: 'Birdwatching', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-5', label: 'Board Games/Puzzles', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-6', label: 'Candle & Soap Making', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-7', label: 'Card Games', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-8', label: 'Chess', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-9', label: 'Cigars', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-10', label: 'Collecting', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-11', label: 'Comic Books', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-12', label: 'Drawing/Sketching', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-13', label: 'Freelance Writing', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-14', label: 'Genealogy', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-15', label: 'Getting Published', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-16', label: 'Guitar', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-17', label: 'Home Recording', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-18', label: 'Investors & Patents', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-19', label: 'Jewelry Making', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-20', label: 'Magic & Illusion', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-21', label: 'Needlework', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-22', label: 'Painting', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-23', label: 'Photography', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-24', label: 'Radio', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-25', label: 'Roleplaying Games', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-26', label: 'Sci-Fi & Fantasy', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-27', label: 'Scrapbooking', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-28', label: 'Screenwriting', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-29', label: 'Stamps & Coins', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-30', label: 'Video & Computer Games', adProduct: { id: 1257, name: 'Hobbies and Interests' } },
        { value: 'IAB9-31', label: 'Woodworking', adProduct: { id: 1257, name: 'Hobbies and Interests' } }
      ]
    },

    'IAB10': {
      label: 'Home & Garden',
      baseAdProduct: { id: 1263, name: 'Home and Garden' },
      subcategories: [
        { value: 'IAB10-1', label: 'Appliances', adProduct: { id: 1264, name: 'Home and Garden > Home Appliances' } },
        { value: 'IAB10-2', label: 'Entertaining', adProduct: { id: 1263, name: 'Home and Garden' } },
        { value: 'IAB10-3', label: 'Environmental Safety', adProduct: { id: 1263, name: 'Home and Garden' } },
        { value: 'IAB10-4', label: 'Gardening', adProduct: { id: 1269, name: 'Home and Garden > Landscaping and Gardening' } },
        { value: 'IAB10-5', label: 'Home Repair', adProduct: { id: 1263, name: 'Home and Garden' } },
        { value: 'IAB10-6', label: 'Home Theater', adProduct: { id: 1263, name: 'Home and Garden' } },
        { value: 'IAB10-7', label: 'Interior Decorating', adProduct: { id: 1263, name: 'Home and Garden' } },
        { value: 'IAB10-8', label: 'Landscaping', adProduct: { id: 1269, name: 'Home and Garden > Landscaping and Gardening' } },
        { value: 'IAB10-9', label: 'Remodeling & Construction', adProduct: { id: 1263, name: 'Home and Garden' } }
      ]
    },

    'IAB11': {
      label: 'Law, Gov\'t & Politics',
      baseAdProduct: { id: 1383, name: 'Government and Legal' },
      subcategories: [
        { value: 'IAB11-1', label: 'Immigration', adProduct: { id: 1383, name: 'Government and Legal' } },
        { value: 'IAB11-2', label: 'Legal Issues', adProduct: { id: 1383, name: 'Government and Legal' } },
        { value: 'IAB11-3', label: 'U.S. Government Resources', adProduct: { id: 1383, name: 'Government and Legal' } },
        { value: 'IAB11-4', label: 'Politics', adProduct: { id: 1383, name: 'Government and Legal' } },
        { value: 'IAB11-5', label: 'Commentary', adProduct: { id: 1383, name: 'Government and Legal' } }
      ]
    },

    'IAB12': {
      label: 'News',
      baseAdProduct: { id: 1419, name: 'Media' },
      subcategories: [
        { value: 'IAB12-1', label: 'International News', adProduct: { id: 1419, name: 'Media' } },
        { value: 'IAB12-2', label: 'National News', adProduct: { id: 1419, name: 'Media' } },
        { value: 'IAB12-3', label: 'Local News', adProduct: { id: 1419, name: 'Media' } }
      ]
    },

    'IAB13': {
      label: 'Personal Finance',
      baseAdProduct: { id: 1360, name: 'Financial Services' },
      subcategories: [
        { value: 'IAB13-1', label: 'Beginning Investing', adProduct: { id: 1372, name: 'Financial Services > Investment Services' } },
        { value: 'IAB13-2', label: 'Credit/Debt & Loans', adProduct: { id: 1364, name: 'Financial Services > Credit and Lending' } },
        { value: 'IAB13-3', label: 'Financial News', adProduct: { id: 1360, name: 'Financial Services' } },
        { value: 'IAB13-4', label: 'Financial Planning', adProduct: { id: 1360, name: 'Financial Services' } },
        { value: 'IAB13-5', label: 'Hedge Fund', adProduct: { id: 1372, name: 'Financial Services > Investment Services' } },
        { value: 'IAB13-6', label: 'Insurance', adProduct: { id: 1375, name: 'Financial Services > Insurance' } },
        { value: 'IAB13-7', label: 'Investing', adProduct: { id: 1372, name: 'Financial Services > Investment Services' } },
        { value: 'IAB13-8', label: 'Mutual Funds', adProduct: { id: 1372, name: 'Financial Services > Investment Services' } },
        { value: 'IAB13-9', label: 'Options', adProduct: { id: 1372, name: 'Financial Services > Investment Services' } },
        { value: 'IAB13-10', label: 'Retirement Planning', adProduct: { id: 1360, name: 'Financial Services' } },
        { value: 'IAB13-11', label: 'Stocks', adProduct: { id: 1372, name: 'Financial Services > Investment Services' } },
        { value: 'IAB13-12', label: 'Tax Planning', adProduct: { id: 1380, name: 'Financial Services > Tax Services' } }
      ]
    },

    'IAB14': {
      label: 'Society',
      baseAdProduct: { id: 1534, name: 'Society and Culture' },
      subcategories: [
        { value: 'IAB14-1', label: 'Dating', adProduct: { id: 1340, name: 'Family and Relationships' } },
        { value: 'IAB14-2', label: 'Divorce Support', adProduct: { id: 1340, name: 'Family and Relationships' } },
        { value: 'IAB14-3', label: 'Gay Life', adProduct: { id: 1534, name: 'Society and Culture' } },
        { value: 'IAB14-4', label: 'Marriage', adProduct: { id: 1340, name: 'Family and Relationships' } },
        { value: 'IAB14-5', label: 'Senior Living', adProduct: { id: 1534, name: 'Society and Culture' } },
        { value: 'IAB14-6', label: 'Teens', adProduct: { id: 1534, name: 'Society and Culture' } },
        { value: 'IAB14-7', label: 'Weddings', adProduct: { id: 1315, name: 'Events and Performances' } },
        { value: 'IAB14-8', label: 'Ethnic Specific', adProduct: { id: 1534, name: 'Society and Culture' } }
      ]
    },

    'IAB15': {
      label: 'Science',
      baseAdProduct: { id: 1510, name: 'Science and Research' },
      subcategories: [
        { value: 'IAB15-1', label: 'Astrology', adProduct: { id: 1510, name: 'Science and Research' } },
        { value: 'IAB15-2', label: 'Biology', adProduct: { id: 1510, name: 'Science and Research' } },
        { value: 'IAB15-3', label: 'Chemistry', adProduct: { id: 1510, name: 'Science and Research' } },
        { value: 'IAB15-4', label: 'Geology', adProduct: { id: 1510, name: 'Science and Research' } },
        { value: 'IAB15-5', label: 'Paranormal Phenomena', adProduct: { id: 1510, name: 'Science and Research' } },
        { value: 'IAB15-6', label: 'Physics', adProduct: { id: 1510, name: 'Science and Research' } },
        { value: 'IAB15-7', label: 'Space/Astronomy', adProduct: { id: 1510, name: 'Science and Research' } },
        { value: 'IAB15-8', label: 'Geography', adProduct: { id: 1510, name: 'Science and Research' } },
        { value: 'IAB15-9', label: 'Botany', adProduct: { id: 1510, name: 'Science and Research' } },
        { value: 'IAB15-10', label: 'Weather', adProduct: { id: 1510, name: 'Science and Research' } }
      ]
    },

    'IAB16': {
      label: 'Pets',
      baseAdProduct: { id: 1475, name: 'Pets and Animals' },
      subcategories: [
        { value: 'IAB16-1', label: 'Aquariums', adProduct: { id: 1475, name: 'Pets and Animals' } },
        { value: 'IAB16-2', label: 'Birds', adProduct: { id: 1475, name: 'Pets and Animals' } },
        { value: 'IAB16-3', label: 'Cats', adProduct: { id: 1475, name: 'Pets and Animals' } },
        { value: 'IAB16-4', label: 'Dogs', adProduct: { id: 1475, name: 'Pets and Animals' } },
        { value: 'IAB16-5', label: 'Large Animals', adProduct: { id: 1475, name: 'Pets and Animals' } },
        { value: 'IAB16-6', label: 'Reptiles', adProduct: { id: 1475, name: 'Pets and Animals' } },
        { value: 'IAB16-7', label: 'Veterinary Medicine', adProduct: { id: 1475, name: 'Pets and Animals' } }
      ]
    },

    'IAB17': {
      label: 'Sports',
      baseAdProduct: { id: 1541, name: 'Sports and Recreation' },
      subcategories: [
        { value: 'IAB17-1', label: 'Auto Racing', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-2', label: 'Baseball', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-3', label: 'Bicycling', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-4', label: 'Bodybuilding', adProduct: { id: 1244, name: 'Health and Wellness > Fitness and Exercise' } },
        { value: 'IAB17-5', label: 'Boxing', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-6', label: 'Canoeing/Kayaking', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-7', label: 'Cheerleading', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-8', label: 'Climbing', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-9', label: 'Cricket', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-10', label: 'Figure Skating', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-11', label: 'Fly Fishing', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-12', label: 'Football', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-13', label: 'Freshwater Fishing', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-14', label: 'Game & Fish', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-15', label: 'Golf', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-16', label: 'Horse Racing', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-17', label: 'Horses', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-18', label: 'Hunting/Shooting', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-19', label: 'Inline Skating', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-20', label: 'Martial Arts', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-21', label: 'Mountain Biking', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-22', label: 'NASCAR Racing', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-23', label: 'Olympics', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-24', label: 'Paintball', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-25', label: 'Power & Motorcycles', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-26', label: 'Pro Basketball', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-27', label: 'Pro Ice Hockey', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-28', label: 'Rodeo', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-29', label: 'Rugby', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-30', label: 'Running/Jogging', adProduct: { id: 1244, name: 'Health and Wellness > Fitness and Exercise' } },
        { value: 'IAB17-31', label: 'Sailing', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-32', label: 'Saltwater Fishing', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-33', label: 'Scuba Diving', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-34', label: 'Skateboarding', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-35', label: 'Skiing', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-36', label: 'Snowboarding', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-37', label: 'Surfing/Bodyboarding', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-38', label: 'Swimming', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-39', label: 'Table Tennis/Ping-Pong', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-40', label: 'Tennis', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-41', label: 'Volleyball', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-42', label: 'Walking', adProduct: { id: 1244, name: 'Health and Wellness > Fitness and Exercise' } },
        { value: 'IAB17-43', label: 'Waterski/Wakeboard', adProduct: { id: 1541, name: 'Sports and Recreation' } },
        { value: 'IAB17-44', label: 'World Soccer', adProduct: { id: 1541, name: 'Sports and Recreation' } }
      ]
    },

    'IAB18': {
      label: 'Style & Fashion',
      baseAdProduct: { id: 1196, name: 'Fashion and Style' },
      subcategories: [
        { value: 'IAB18-1', label: 'Beauty', adProduct: { id: 1196, name: 'Fashion and Style' } },
        { value: 'IAB18-2', label: 'Body Art', adProduct: { id: 1196, name: 'Fashion and Style' } },
        { value: 'IAB18-3', label: 'Fashion', adProduct: { id: 1196, name: 'Fashion and Style' } },
        { value: 'IAB18-4', label: 'Jewelry', adProduct: { id: 1196, name: 'Fashion and Style' } },
        { value: 'IAB18-5', label: 'Clothing', adProduct: { id: 1196, name: 'Fashion and Style' } },
        { value: 'IAB18-6', label: 'Accessories', adProduct: { id: 1196, name: 'Fashion and Style' } }
      ]
    },

    'IAB19': {
      label: 'Technology & Computing',
      baseAdProduct: { id: 1074, name: 'Computer Software' },
      subcategories: [
        { value: 'IAB19-1', label: '3-D Graphics', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-2', label: 'Animation', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-3', label: 'Antivirus Software', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-4', label: 'C/C++', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-5', label: 'Cameras & Camcorders', adProduct: { id: 1154, name: 'Electronics' } },
        { value: 'IAB19-6', label: 'Cell Phones', adProduct: { id: 1166, name: 'Electronics > Mobile Devices' } },
        { value: 'IAB19-7', label: 'Computer Certification', adProduct: { id: 1281, name: 'Learning and Knowledge > Education' } },
        { value: 'IAB19-8', label: 'Computer Networking', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-9', label: 'Computer Peripherals', adProduct: { id: 1154, name: 'Electronics' } },
        { value: 'IAB19-10', label: 'Computer Reviews', adProduct: { id: 1154, name: 'Electronics' } },
        { value: 'IAB19-11', label: 'Data Centers', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-12', label: 'Databases', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-13', label: 'Desktop Publishing', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-14', label: 'Desktop Video', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-15', label: 'Email', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-16', label: 'Graphics Software', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-17', label: 'Home Video/DVD', adProduct: { id: 1154, name: 'Electronics' } },
        { value: 'IAB19-18', label: 'Internet Technology', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-19', label: 'Java', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-20', label: 'JavaScript', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-21', label: 'Mac Support', adProduct: { id: 1154, name: 'Electronics' } },
        { value: 'IAB19-22', label: 'MP3/MIDI', adProduct: { id: 1154, name: 'Electronics' } },
        { value: 'IAB19-23', label: 'Net Conferencing', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-24', label: 'Net for Beginners', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-25', label: 'Network Security', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-26', label: 'Palmtops/PDAs', adProduct: { id: 1166, name: 'Electronics > Mobile Devices' } },
        { value: 'IAB19-27', label: 'PC Support', adProduct: { id: 1154, name: 'Electronics' } },
        { value: 'IAB19-28', label: 'Portable', adProduct: { id: 1154, name: 'Electronics' } },
        { value: 'IAB19-29', label: 'Entertainment', adProduct: { id: 1154, name: 'Electronics' } },
        { value: 'IAB19-30', label: 'Shareware/Freeware', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-31', label: 'Unix', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-32', label: 'Visual Basic', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-33', label: 'Web Clip Art', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-34', label: 'Web Design/HTML', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-35', label: 'Web Search', adProduct: { id: 1074, name: 'Computer Software' } },
        { value: 'IAB19-36', label: 'Windows', adProduct: { id: 1074, name: 'Computer Software' } }
      ]
    },

    'IAB20': {
      label: 'Travel',
      baseAdProduct: { id: 1547, name: 'Travel and Tourism' },
      subcategories: [
        { value: 'IAB20-1', label: 'Adventure Travel', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-2', label: 'Africa', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-3', label: 'Air Travel', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-4', label: 'Australia & New Zealand', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-5', label: 'Bed & Breakfasts', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-6', label: 'Budget Travel', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-7', label: 'Business Travel', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-8', label: 'By US Locale', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-9', label: 'Camping', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-10', label: 'Canada', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-11', label: 'Caribbean', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-12', label: 'Cruises', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-13', label: 'Eastern Europe', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-14', label: 'Europe', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-15', label: 'France', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-16', label: 'Greece', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-17', label: 'Honeymoons/Getaways', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-18', label: 'Hotels', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-19', label: 'Italy', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-20', label: 'Japan', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-21', label: 'Mexico & Central America', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-22', label: 'National Parks', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-23', label: 'South America', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-24', label: 'Spas', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-25', label: 'Theme Parks', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-26', label: 'Traveling with Kids', adProduct: { id: 1547, name: 'Travel and Tourism' } },
        { value: 'IAB20-27', label: 'United Kingdom', adProduct: { id: 1547, name: 'Travel and Tourism' } }
      ]
    },

    'IAB21': {
      label: 'Real Estate',
      baseAdProduct: { id: 1494, name: 'Real Estate' },
      subcategories: [
        { value: 'IAB21-1', label: 'Apartments', adProduct: { id: 1494, name: 'Real Estate' } },
        { value: 'IAB21-2', label: 'Architects', adProduct: { id: 1494, name: 'Real Estate' } },
        { value: 'IAB21-3', label: 'Buying/Selling Homes', adProduct: { id: 1494, name: 'Real Estate' } }
      ]
    },

    'IAB22': {
      label: 'Shopping',
      baseAdProduct: { id: 1515, name: 'Shopping and Consumer Resources' },
      subcategories: [
        { value: 'IAB22-1', label: 'Contests & Freebies', adProduct: { id: 1515, name: 'Shopping and Consumer Resources' } },
        { value: 'IAB22-2', label: 'Couponing', adProduct: { id: 1515, name: 'Shopping and Consumer Resources' } },
        { value: 'IAB22-3', label: 'Comparison', adProduct: { id: 1515, name: 'Shopping and Consumer Resources' } },
        { value: 'IAB22-4', label: 'Engines', adProduct: { id: 1515, name: 'Shopping and Consumer Resources' } }
      ]
    },

    'IAB23': {
      label: 'Religion & Spirituality',
      baseAdProduct: { id: 1507, name: 'Religion and Spirituality' },
      subcategories: [
        { value: 'IAB23-1', label: 'Alternative Religions', adProduct: { id: 1507, name: 'Religion and Spirituality' } },
        { value: 'IAB23-2', label: 'Atheism/Agnosticism', adProduct: { id: 1507, name: 'Religion and Spirituality' } },
        { value: 'IAB23-3', label: 'Buddhism', adProduct: { id: 1507, name: 'Religion and Spirituality' } },
        { value: 'IAB23-4', label: 'Catholicism', adProduct: { id: 1507, name: 'Religion and Spirituality' } },
        { value: 'IAB23-5', label: 'Christianity', adProduct: { id: 1507, name: 'Religion and Spirituality' } },
        { value: 'IAB23-6', label: 'Hinduism', adProduct: { id: 1507, name: 'Religion and Spirituality' } },
        { value: 'IAB23-7', label: 'Islam', adProduct: { id: 1507, name: 'Religion and Spirituality' } },
        { value: 'IAB23-8', label: 'Judaism', adProduct: { id: 1507, name: 'Religion and Spirituality' } },
        { value: 'IAB23-9', label: 'Latter-Day Saints', adProduct: { id: 1507, name: 'Religion and Spirituality' } },
        { value: 'IAB23-10', label: 'Pagan/Wiccan', adProduct: { id: 1507, name: 'Religion and Spirituality' } }
      ]
    },

    'IAB24': {
      label: 'Uncategorized',
      baseAdProduct: { id: 1000, name: 'Uncategorized' },
      subcategories: []
    },

    'IAB25': {
      label: 'Non-Standard Content',
      baseAdProduct: { id: 1001, name: 'Non-Standard Content' },
      subcategories: []
    },

    'IAB26': {
      label: 'Illegal Content',
      baseAdProduct: { id: 1002, name: 'Illegal Content' },
      subcategories: []
    }
  }
};

// Helper function to get subcategories for a content category
export const getSubcategoriesForCategory = (categoryId) => {
  const categoryData = COMPLETE_TAXONOMY_DATA.detailedMapping[categoryId];
  if (!categoryData) return [];
  
  return [
    // Always include the base category option
    {
      value: categoryId,
      label: `${categoryId} (Base Category)`,
      adProduct: categoryData.baseAdProduct
    },
    // Include all subcategories
    ...categoryData.subcategories || []
  ];
};

// Helper function to get ad product for a specific selection
export const getAdProductForSelection = (categoryId, subcategoryId = null) => {
  const categoryData = COMPLETE_TAXONOMY_DATA.detailedMapping[categoryId];
  if (!categoryData) return null;
  
  if (!subcategoryId || subcategoryId === categoryId) {
    return categoryData.baseAdProduct;
  }
  
  const subcategory = categoryData.subcategories?.find(sub => sub.value === subcategoryId);
  return subcategory?.adProduct || categoryData.baseAdProduct;
};